import { useTranslation } from "react-i18next";
import NavBreadcrum from "components/NavBreadcrum";
import MenuButtons from "components/MenuButtons";
import navs from "./navs";
import navsBridge from "./navsBridge";
import { useContext } from "react";
import AuthContext from "context/AuthContext";

const MainAssetManagement = () => {
  const [t] = useTranslation("routes");
  const { panel } = useContext(AuthContext);
  const bread = [
    { name: t("labels.asset-management"), current: true }
  ];


  return (
    <>
      {panel.panel_type === "w" ? (
        <NavBreadcrum navs={navs} bread={bread} />
      ) : (
        <NavBreadcrum navs={navsBridge} bread={bread} />
      )}

      <MenuButtons navs={navs} />
    </>
  );
};

export default MainAssetManagement;